// What a Research Task's due time stands for (ADR-0176, a Company whose only
// due Research Tasks are retries is not stale).
export enum DueReason {
  NEVER_CHECKED = "never_checked",
  STALE = "stale",
  RETRY = "retry",
  DEFERRED = "deferred",
}
